import { Component, OnInit, Input } from '@angular/core';
import { BindingContext } from '../../models/BindingContext';

@Component({
	selector: 'app-binding-context-alert-component',
	templateUrl: './binding-context-alert-component.html',
	styleUrls: ['./binding-context-alert-component.scss']
})
export class BindingContextAlertComponent implements OnInit {
	_bindingContext: BindingContext;

	set bindingContext(input: BindingContext) {
		this._bindingContext = input;
	}

	@Input('bindingContext')
	get bindingContext(): BindingContext {
		if (!this._bindingContext) {
			throw Error('bindingContext not set.');
		}
		return this._bindingContext;
	}

	constructor() {}

	ngOnInit() {}
}
